import { call } from 'redux-saga/effects'
import redirectTo from '../../../utils/redirect/redirectTo'

export default function*(request, data, handleSuccess, handleError) {
  try {
    const result = yield call(request, data)

    yield handleSuccess(result)
  } catch (error) {
    if (error.redirect_uri) {
      redirectTo(error.redirect_uri)
    } else {
      yield handleError(error)
    }
  }
}
